import React from "react";
import type { FooterProps } from "@/types";

export default function Footer({ variant, bgColor, businessUnitName }: FooterProps) {
    const getBackgroundClass = () => {
        if (bgColor === 'brand-blue') {
            return "bg-brand-blue";
        } else if (bgColor === 'brand-red') {
            return "bg-brand-red";
        } else if (bgColor && bgColor.startsWith('#')) {
            return "";
        } else if (bgColor) {
            return "";
        }
        return variant === "black" ? "bg-black" : variant === "blue" ? "bg-brand-blue" : "bg-brand-blue";
    };

    const getInlineStyles = () => {
        if (bgColor && (bgColor.startsWith('#') || bgColor.startsWith('var('))) {
            return { backgroundColor: bgColor };
        }
        return {};
    };

    const getTextClass = () => {
        if (bgColor) {
            if (bgColor === 'brand-blue') {
                return "text-gray-200"; 
            } else if (bgColor === 'brand-red') {
                return "text-white"; 
            } else if (bgColor && bgColor.startsWith('#')) {
                return "text-white";
            } else {
                return "text-white"; 
            }
        }
        return variant === "black" ? "text-gray-300" : variant === "blue" ? "text-gray-200" : "text-gray-200";
    };

    const getBorderClass = () => {
        if (bgColor) {
            return "border-gray-600";
        }
        return variant === "black" ? "border-gray-700" : variant === "blue" ? "border-gray-500" : "border-gray-500";
    };

    return (
        <footer 
            className={`w-full text-xs ${getBackgroundClass()} ${getTextClass()}`}
            style={getInlineStyles()}
        >
            <div className={`border-t ${getBorderClass()} w-full`} />

            <div className="text-right py-3 pr-20">
                © 2025 {businessUnitName ? `by ${businessUnitName}®` : 'Coventry Group Ltd. All rights reserved.'}
            </div>
        </footer>
    );
}
